"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paper = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _paperModule = _interopRequireDefault(require("./paper.module.scss"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _excluded = ["className", "children", "inModal"];
var Paper = /*#__PURE__*/_react.default.forwardRef(function Paper(_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    inModal = _ref.inModal,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("ul", Object.assign({
    className: (0, _classnames2.default)(_paperModule.default.paper, className, (0, _defineProperty2.default)({}, _paperModule.default['paper--in-modal'], inModal))
  }, rest, {
    ref: ref
  }), children);
});
exports.Paper = Paper;
Paper.displayName = 'Paper';